import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {UserService} from '../../services/user.service';
import {AppCommunicationService} from '../../services/app-communication.service';
import {ModalDirective} from 'ngx-bootstrap';
import {GeneralService} from '../../services/general.service';
import {ParticipantModel} from '../../models/participant.model';
import {ExternalUserModalFormComponent} from '../external-user-modal-form/external-user-modal-form.component';
import {UserModel} from '../../models/user.model';
import {AuthorModel} from '../../models/author.model';

@Component({
    selector: 'app-user-search',
    templateUrl: './user-search.component.html',
    styleUrls: ['./user-search.component.scss']
})
export class UserSearchComponent implements OnInit {
    data = [];

    states = {
        opened: false,
        searching: false,
        submitted: false
    };

    externalUserFormValid = false;

    @Output() submittedParticipant: EventEmitter<any> = new EventEmitter<any>();

    @Output() onDeleteParticipant: EventEmitter<boolean> = new EventEmitter<boolean>();

    @Input() selectedUser: AuthorModel | UserModel;

    @Input() withAddress: boolean;

    @Input() withoutEmail = false;

    @ViewChild('searchInput') searchInput: ElementRef;

    @ViewChild('externalUserModal') externalUserModal: ModalDirective;

    @ViewChild(ExternalUserModalFormComponent) externalModalForm: ExternalUserModalFormComponent;

    constructor(
        private _userService: UserService,
        private _appCommunicationService: AppCommunicationService
    ) {
    }

    ngOnInit() {
        if (this.selectedUser.name && this.selectedUser.surname) {
            this.states.opened = true;
            this.states.submitted = true;
        }
    }

    onExternalUserSubmit(user) {
        this.selectedUser = user;
    }

    onExternalUserSubmitForm() {
        if (this.externalUserFormValid) {
            this.states.opened = true;
            this.states.searching = false;
            this.externalUserModal.hide();
        }
    }

    externalUserFormValidChange(val) {
        this.externalUserFormValid = !!val;
    }

    onFilterUsers(event) {
        this._userService
            .searchUser(event.query)
            .subscribe(val => {
                if (val === null) {
                    val = [];
                    val.push({
                        id: 0,
                        title: 'Nenašli ste čo ste hľadali?',
                        name: '',
                        surname: '',
                        titleAfter: '',
                        workCenterCode: '',
                        facultyCode: ''
                    })
                } else {
                    val.push({
                        id: 0,
                        title: 'Nenašli ste čo ste hľadali?',
                        name: '',
                        surname: '',
                        titleAfter: '',
                        workCenterCode: '',
                        facultyCode: ''
                    });
                }
                this.data = val
            })
    }

    onSelectOption() {
        if (this.selectedUser.id === 0) {
            this.openExternalUserModal();
            this.externalModalForm.onNewUserForm();
            return;
        }
        this.states.submitted = false;
        this._appCommunicationService.loadingOn('Načítavam dáta.');
        this.states.searching = false;
        this._userService
            .getSearched(this.selectedUser)
            .subscribe(user => {
                this.selectedUser = user;
                this._appCommunicationService.loadingOff();
            }, () => {
                this._appCommunicationService.loadingOff();
                this.states.searching = true;
            });
    }

    openExternalUserModal() {
        this.externalUserModal.show();
    }

    onSubmitParticipant() {
        this.submittedParticipant.emit(this.selectedUser);
        this.states.submitted = true;
    }

    toggleSearching() {
        this.states.searching = !this.states.searching;
    }

    onCloseButton() {
        this.states.opened = false;
        this.states.searching = false;
        if (this.states.submitted) {
            this.onDeleteParticipant.emit(true);
            this.states.submitted = false;
        }
    }

    onAddParticipantButton() {
        this.states.opened = true;
        this.states.searching = true;
    }


}



// WEBPACK FOOTER //
// ./src/app/+app-custom/components/user-search/user-search.component.ts